export const actions = {
  updateUser: ({ commit }, user) => {
    commit('setUser', user);
  },
  updateStatus: ({ commit }, status: boolean) => {
    commit('setStatus', status);
  },
};
